function TopicHeader({ title }) {
  return (
    <div className="intake-mid-bdy-hdr">
      <span
        className="widget-hdr-title bold clear-top"
        style={{ color: 'white' }}
      >
        {title}
      </span>
    </div>
  );
}

export default TopicHeader;
